import React, { Component } from 'react';
import { connect } from 'react-redux'
import AcaoRepasseVenda from './AcaoRepasseVenda';
import { tipoRepasseVenda } from '../../util/constantsUtil';
import { DetalheHistoricoRepasse } from './DetalheHistoricoRepasse';
import selecionarRepasse from '../../actions/repasse-venda/selecionarRepasseVenda';
import moment from 'moment';

const CabecalhoTabela = (tipo) => (
    <div id="header-tabela" className="lista-table d-md-block d-lg-block d-xl-block d-none d-sm-none">
        <div className="row cabecalho-desktop">
            <div className="col-auto mr-4"></div>
            <div className="col">Data Repasse</div>
            {tipo === tipoRepasseVenda.empresa.nome ? <div className="col">Empresa</div> : ''}
            {tipo === tipoRepasseVenda.vendedor.nome ? <div className="col">Vendedor</div> : ''}
            {tipo === tipoRepasseVenda.imposto.nome ? <div className="col">Grupo</div> : ''}
            <div className="col">Total Taxa Serviço</div>
            <div className="col">Total Comissão</div>
            <div className="col">Total Imposto</div>
            <div className="col">Total Custo Cancelamento</div>
            <div className="col">Total Faturado</div>
            {tipo === tipoRepasseVenda.empresa.nome ?             
                <div className="col">Líquido Empresa</div> : ''}
            <div className="col">Total Repasse</div>
            <div className="col">Ações</div>
        </div>
    </div>
);

export class AbaHistoricoRepasse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visualizarDetalheHistorico: false
        }
    }

    alterarExibicao() {
        this.setState({ visualizarDetalheHistorico: !this.state.visualizarDetalheHistorico });
    }

    exibirIcone() {
        if (this.state.visualizarDetalheHistorico) {
            return <i className="material-icons" style={{ cursor: 'pointer' }} >
                &#xE5C7;</i>
        }
        return <i className="material-icons" style={{ cursor: 'pointer' }}>&#xE5C5;</i>
    }

    render() {
        const tipo = this.props.tipoRepasseVenda;
        
        const repasseEmpresa = tipo === tipoRepasseVenda.empresa.nome;
        const repasseVendedor = tipo === tipoRepasseVenda.vendedor.nome;
        const repasseImposto = tipo === tipoRepasseVenda.imposto.nome;
        
        return (
            <>
                {CabecalhoTabela(this.props.tipoRepasseVenda, this.props.abaRepasseVendaSelecionada)}
                <div className="lista-table">
                    <div className="geral">
                        {this.props.repasseVenda.map((it, index) => <div className={''} key={index}>
                            <div className='row resumo'>
                                <div className="col-auto" style={{ cursor: 'pointer' }} onClick={() => this.alterarExibicao()}>
                                    {this.exibirIcone()}
                                </div>

                                <div className="col">
                                    <span className="titulo-mobile">Data Embarque:&nbsp;</span>
                                    {moment(it.data).format('DD/MM/YYYY')}
                                </div>

                                {this.props.tipoRepasseVenda == tipoRepasseVenda.empresa.nome ? 
                                <div className="col">
                                    <span className="titulo-mobile">Empresa:&nbsp;</span>{it.nomeEmpresa}
                                </div> : ''}

                                {this.props.tipoRepasseVenda == tipoRepasseVenda.imposto.nome ?
                                 <div className="col">
                                    <span className="titulo-mobile">Grupo:&nbsp;</span> {it.grupo}
                                </div> : '' }

                                {this.props.tipoRepasseVenda == tipoRepasseVenda.vendedor.nome ?
                                <div className="col">
                                    <span className="titulo-mobile">Vendedor:&nbsp;</span> {it.nomeUsuario}
                                </div> : ''}

                                <div className="col">
                                    <span className="titulo-mobile">Total Taxa Servico R$:&nbsp;</span>
                                    {Number(it.totalTaxaServico)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                </div>
                                <div className="col">
                                    <span className="titulo-mobile">Total Comissão R$:&nbsp;</span>
                                    {Number(it.totalComissao)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                </div>
                                <div className="col">
                                    <span className="titulo-mobile">Total Imposto R$:&nbsp;</span>
                                    {Number(it.totalImposto)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                </div>
                                <div className="col">
                                    <span className="titulo-mobile">Total Custo Cancelamento R$:&nbsp;</span>
                                    {Number(it.totalCustoCancelamento)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                </div>
                                <div className="col">
                                    <span className="titulo-mobile">Total Faturado R$:&nbsp;</span>
                                    {Number(it.valorTotalFaturadoReservas)
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                </div>
                                {tipo === tipoRepasseVenda.empresa.nome ?
                                    <div className="col">
                                        <span className="titulo-mobile">Líquido Empresa R$:&nbsp;</span>
                                        {Number(it.valorLiquido)
                                            .toLocaleString('pt-br', {
                                                style: 'currency',
                                                currency: 'BRL'
                                            })}
                                    </div> : ''}
                                <div className="col">
                                    <span className="titulo-mobile">Total Repasse R$:&nbsp;</span>
                                    {Number(repasseEmpresa ? it.valorLiquido : '' ||
                                            repasseVendedor ? it.totalComissao : '' ||
                                            repasseImposto ? it.totalImposto : '')
                                        .toLocaleString('pt-br', {
                                            style: 'currency',
                                            currency: 'BRL'
                                        })}
                                    </div>
                                <div className="col">
                                    <span className="titulo-mobile">Ações:&nbsp;</span>
                                    <AcaoRepasseVenda aba={this.props.abaRepasseVendaSelecionada} repasseSelecionado={it} selecionarRepasse={this.props.selecionarRepasse.bind(this)} />
                                </div>
                            </div>
                            <DetalheHistoricoRepasse tipo={this.props.tipoRepasseVenda} item={it} visualizarDetalheHistorico={this.state.visualizarDetalheHistorico} />
                        </div>)}
                        {this.props.repasseVenda.length === 0 &&
                            <div className="alert alert-warning text-center" role="alert">
                                Não foi encontrado resultado para sua pesquisa.
                            </div>}
                    </div>
                </div>
            </>
        )
    }
}

export const mapStateToProps = state => (
    {
        repasseVenda: state.repasseVenda,
    });

export default connect(mapStateToProps,
    {
        selecionarRepasse
    }
)(AbaHistoricoRepasse)